import PropTypes from 'prop-types'

export const QuestionMarkIcon = ({className, title = null}) => (
  <svg
    aria-hidden={!title}
    className={className}
    fill='none'
    height='17'
    role={title ? 'img' : null}
    viewBox='0 0 17 17'
    width='17'
    xmlns='http://www.w3.org/2000/svg'>
    {title ? <title>{title}</title> : null}
    <path
      d='M6.4825 4.51583C7.45833 3.66167 9.04167 3.66167 10.0175 4.51583C10.9942 5.37 10.9942 6.755 10.0175 7.60917C9.84833 7.75833 9.65917 7.88083 9.45917 7.9775C8.83833 8.27833 8.25083 8.81 8.25083 9.5V10.125M15.75 8.25C15.75 9.23491 15.556 10.2102 15.1791 11.1201C14.8022 12.0301 14.2497 12.8569 13.5533 13.5533C12.8569 14.2497 12.0301 14.8022 11.1201 15.1791C10.2102 15.556 9.23491 15.75 8.25 15.75C7.26509 15.75 6.28982 15.556 5.37987 15.1791C4.46993 14.8022 3.64314 14.2497 2.9467 13.5533C2.25026 12.8569 1.69781 12.0301 1.3209 11.1201C0.943993 10.2102 0.75 9.23491 0.75 8.25C0.75 6.26088 1.54018 4.35322 2.9467 2.9467C4.35322 1.54018 6.26088 0.75 8.25 0.75C10.2391 0.75 12.1468 1.54018 13.5533 2.9467C14.9598 4.35322 15.75 6.26088 15.75 8.25ZM8.25 12.625H8.25667V12.6317H8.25V12.625Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
  </svg>
)

QuestionMarkIcon.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string
}
